<template>
  <div class="bg">
    <!-- 操作栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="goBackBox" @click="goBack">
          <img class="goBackIcon" src="@/assets/backIcon.svg" />
          <span class="goBackTitle">{{$t('message.backText')}}</span>
        </div>
        <p class="operationText marginLeft">{{$t('message.orderTableTitle1')}}：{{orderNum}}</p>
      </div>
      <div class="search_box">
        <div class="add_btn" @click="addNewLogistics" v-if="isAdmin"><img class="add_icon" src="@/assets/addIcon.svg" />{{$t('message.addNewLogisticsText')}}</div>
        <div class="add_btn marginLeft" v-if="isAdmin" @click="startLogistics">{{$t('message.startLogistics')}}</div>
        <div class="add_btn marginLeft" v-if="isAdmin" @click="endLogistics">{{$t('message.endlogistics')}}</div>
      </div>
    </div>
    <!-- 操作栏 -->
    <!-- 列表 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="logisticsList" :data="logisticsList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column :label="$t('message.goodsStatusTitle')" prop="HWZK" width="120"></el-table-column>
          <el-table-column :label="$t('message.deliveryStatusTitle')" prop="PSZK" width="120"></el-table-column>
          <el-table-column :label="$t('message.positionTitle')" prop="GUDING1" min-width="200"></el-table-column>
          <el-table-column :label="$t('message.dateTitle')" prop="RQ" width="200"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="200" v-if="isAdmin">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button class="operate_btn updateBtn" type="text" size="small" @click.native.prevent="updateLogistics(scope.row)"></el-button>
                <el-button class="operate_btn delBtn" type="text" size="small" @click.native.prevent="delLogistics(scope.row)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 列表 -->
    <el-dialog :title="dialogTitle" :visible.sync="newLogistics" destroy-on-close :close-on-click-modal="false" center :modal-append-to-body="false" width="30%">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.goodsStatusTitle')}}</span>
            <el-input v-model="goodsStatus" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.deliveryStatusTitle')}}</span>
            <el-input v-model="deliveryStatus" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.positionTitle')}}</span>
            <el-input v-model="position" :placeholder="$t('message.placeholder')" type="textarea"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <span class="dialog_item_title">{{$t('message.dateTitle')}}</span>
            <el-date-picker v-model="logisticsDate" type="datetime" :placeholder="$t('message.placeholder')" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item" v-if="dialogTitle === $t('message.endlogistics')">
            <span class="dialog_item_title">{{$t('message.uploadReceipt')}}</span>
            <el-upload :action="uploadPhotoUrl" :limit="1" :on-success="uploadSuccess" class="uploadPhotoBox">
              <el-button size="small" type="primary" class="uploadPhotoBtn">{{$t('message.uploadReceipt')}}</el-button>
            </el-upload>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="newLogistics = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="addLogistics">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getLogistics, setLogistics, delLogistics, startDistribution, endLogistics, endOrder, uploadPhoto } from '@/api/getData.js'
  export default {
    name: 'logisticsManage',
    data () {
      return {
        isAdmin: false,
        orderNum: '',
        id: '',
        logisticsList: [],
        newLogistics: false,
        newId: 0,
        goodsStatus: '',
        deliveryStatus: '',
        position: '',
        logisticsDate: '',
        dialogTitle: '',
        fileName: ''
      }
    },
    created() {
      this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin')
      this.orderNum = this.$route.query.orderNum
      this.id = this.$route.query.id
      this.getLogistics()
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      },
      // 查询物流信息
      async getLogistics () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = { PID: this.orderNum }
        let res = await getLogistics(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data.dt)
        let index = 0
        this.logisticsList = res.data.dt.map(item => {
          item.index = ++index
          return item
        })
      },
      // 添加新的物流信息
      addNewLogistics () {
        this.newId = 0
        this.goodsStatus = this.$t('message.normalCondition')
        this.deliveryStatus = this.$t('message.normalCondition')
        this.position = ''
        this.logisticsDate = ''
        this.newLogistics = true
        this.dialogTitle = this.$t('message.addNewLogisticsText')
      },
      // 开始配送
      startLogistics () {
        this.newId = 0
        this.goodsStatus = this.$t('message.normalCondition')
        this.deliveryStatus = this.$t('message.normalCondition')
        this.position = ''
        this.logisticsDate = ''
        this.newLogistics = true
        this.dialogTitle = this.$t('message.startLogistics')
      },
      addLogistics () {
        if (this.dialogTitle === this.$t('message.startLogistics')) {
          this.addNewConfirm(1)
        } else if (this.dialogTitle === this.$t('message.addNewLogisticsText')) {
          this.addNewConfirm(0)
        } else if (this.dialogTitle === this.$t('message.endlogistics')) {
          this.addEndLogistics()
        }
      },
      // 确定添加物流信息
      async addNewConfirm (status) {
        if (!this.goodsStatus) {
          this.$message.error(this.$t('message.goodsStatusTitle'))
        } else if (!this.deliveryStatus) {
          this.$message.error(this.$t('message.deliveryStatusTitle'))
        } else if (!this.position) {
          this.$message.error(this.$t('message.positionTitle'))
        } else if (!this.logisticsDate) {
          this.$message.error(this.$t('message.dateTitle'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let param = {
            PID: this.orderNum,
            ID: this.newId,
            HWZK: this.goodsStatus,
            PSZK: this.deliveryStatus,
            GUDING1: this.position,
            RQ: this.logisticsDate,
            GUDING2: this.$store.state.JHSS.personalUserid
          }
          // console.log(param)
          let res = null
          if (status === 0) {
            res = await setLogistics(param)
          } else {
            res = await startDistribution(param)
          }
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
            return
          }
          // console.log(res.data)
          if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.newLogistics = false
            this.getLogistics()
          }
        }
      },
      // 完成配送
      endLogistics () {
        this.newId = 0
        this.goodsStatus = this.$t('message.normalCondition')
        this.deliveryStatus = this.$t('message.normalCondition')
        this.position = ''
        this.logisticsDate = ''
        this.newLogistics = true
        this.dialogTitle = this.$t('message.endlogistics')
      },
      async addEndLogistics () {
        if (!this.goodsStatus) {
          this.$message.error(this.$t('message.goodsStatusTitle'))
        } else if (!this.deliveryStatus) {
          this.$message.error(this.$t('message.deliveryStatusTitle'))
        } else if (!this.position) {
          this.$message.error(this.$t('message.positionTitle'))
        } else if (!this.logisticsDate) {
          this.$message.error(this.$t('message.dateTitle'))
        } else {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let param = {
            PID: this.orderNum,
            ID: this.newId,
            HWZK: this.goodsStatus,
            PSZK: this.deliveryStatus,
            GUDING1: this.position,
            RQ: this.logisticsDate,
            GUDING2: this.$store.state.JHSS.personalUserid,
            GUDING3: this.fileName
          }
          // console.log(param)
          let res = await endLogistics(param)
          loading.close()
          if (res.status !== 200) {
            this.$message.error('network error：' + res.status)
            return
          }
          // console.log(res.data)
          if (res.data.result !== '1') {
            this.$message.error(res.data.message)
          } else {
            this.newLogistics = false
            this.$router.replace({ path: '/logisticsCheck', query: { orderNum: this.orderNum } })
          }
        }
      },
      // 修改物流信息
      updateLogistics (obj) {
        // console.log(obj)
        this.newLogistics = true
        this.dialogTitle = this.$t('message.updateLogisticsText')
        this.newId = obj.ID
        this.goodsStatus = obj.HWZK
        this.deliveryStatus = obj.PSZK
        this.position = obj.GUDING1
        this.logisticsDate = obj.RQ
      },
      // 删除物流信息
      delLogistics (obj) {
        // console.log(obj)
        this.$confirm(this.$t('message.logisticsPrompt'), this.$t('message.promptTitle'), {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.del(obj.ID)
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async del (id) {
        let param = { ID: id }
        let res = await delLogistics(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.getLogistics()
        }
      },
      // 确认订单已完成
      confirmOrderComplete () {
        this.$confirm(this.$t('message.orderHasCompleteText') + '？', this.$t('message.promptTitle'), {
          closeOnClickModal: false,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText')
        }).then(() => {
          this.confirmComplete()
        }).catch(() => {
          this.$message(this.$t('message.canclePrompt'));
        });
      },
      async confirmComplete () {
        let param = { ID: this.id }
        let res = await endOrder(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.$router.go(-1)
        }
      },
      // beforeAvatarUpload (file) {
      //   const isJPG = file.type === 'image/jpeg'
      //   if (!isJPG) {
      //     this.$message.error(this.$t('message.uploadImgErrorFormatText'))
      //   }
      //   return isJPG
      // },
      uploadSuccess (file) {
        // console.log(file)
        this.fileName = file.newFileName
      }
    },
    computed: {
      uploadPhotoUrl () {
        return uploadPhoto
      }
    }
  }
</script>

<style scoped>
.operationText {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #333333;
  line-height: 27px;
}
.marginLeft {
  margin-left: 20px;
}
.uploadPhotoBox {
  width: 280px;
  display: flex;
  align-items: center;
}
.uploadPhotoBtn {
  margin-right: 10px;
}
</style>
